
const authStrategies = {
    role(options, selType, moduleType) {
        const { investigationSiteName, invId, siteId, curRole, userName } = sessionStorage;
        if (selType == 0) {
            if (invId > 0 || siteId > 0) {
                return com => '';
            }
        } else if (selType == 1) {//中心汇总
            if (invId == 0 || siteId > 0 || !investigationSiteName) {
                return com => '';
            }
        } else if (selType == 3) {//配置项目
            if (invId == 0 || siteId > 0 || investigationSiteName) {
                return com => '';
            }
        } else if (selType == 2) {//具体中心
            if (invId == 0 || siteId == 0) {
                return com => '';
            }
        }
        if (options == null || options.length == 0 || options.includes(curRole)) {
            return com => com;
        } else {
            if (moduleType === 'quotation') {
                if (curRole === 'BO' && userName === '王丽芬') {
                    return com => com;
                }
            }
        }
        return com => '';
    },
    permission(options) {
        let show = false;
        const permissions = JSON.parse(sessionStorage.getItem('permission'));
        for (let i = 0; i < permissions.length; i++) {
            const permission = permissions[i].name;
            if (options.includes(permission)) {
                show = true;
                break;
            }
        }
        return com => show ? com : '';
    },
};

const Auth = function (key, options, selType, moduleType) {
    return authStrategies[key](options, selType, moduleType);
};

export default Auth;

// 验证权限
// auth('permission', ['模板:添加,修改,删除', '权限:/permission/list'])(component)



// WEBPACK FOOTER //
// ./src/common/Auth.js